import {getCurrentYear} from '../../utils/commons'
import Top10WorthItLogo from './logo'
import {top10WorthItStylesUS} from './styles'

const baseConfig = {
  domainName: 'top10worthit' as const,
  domainType: 'deals' as const,
  siteName: 'Top 10 Worth It',
  favicon: '/favicons/top10worthit.png',
}

const localeConfigs = {
  us: {
    measurementId: 'G-YD30NF5TLH',
    camelCaseUrl: 'Top10WorthIt.com',
    logo: <Top10WorthItLogo className="size-10 shrink-0 tablet:size-8" />,
    title: (category: string, count: string) =>
      `Top ${count} ${category} ${getCurrentYear()} in the US | Top10WorthIt.com - Expert Reviews & Buying Guides`,
    description: (category?: string, count?: string) =>
      `Discover the top ${count} ${category} for ${getCurrentYear()} in the US at Top10WorthIt.com. Unbiased reviews, top picks, and helpful buying guides to help you choose the best.`,
    styles: top10WorthItStylesUS,
  },
}

export const createConfig = (locale: string = 'us') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.us
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
